import React, { useEffect, useState, useRef } from "react";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Textarea from "components/Textarea";
import useStyles from "./styles";

interface Props {
  className?: string;
  defaultValue?: string;
  placeholder?: string;
  name: string;
  onChange: (name: string, value: string) => void;
  changeTempValue?: (value: string) => void;
  withoutControls: boolean;
  disabled: boolean;
  hasNoteChanges: boolean;
  shouldUpdateNotesBlockValue?: string | null;
}

const NoteBlock = (props: Props) => {
  const {
    className,
    defaultValue,
    onChange,
    name,
    placeholder,
    withoutControls,
    disabled,
    hasNoteChanges,
    changeTempValue,
    shouldUpdateNotesBlockValue
  } = props;
  const classes = useStyles();
  const [edit, setEdit] = useState<boolean>(false);
  const [lastValue, setLastValue] = useState<string>(defaultValue || "");
  const [value, setValue] = useState<string>(defaultValue || "");

  const noteRef = useRef(null);

  const handlePreviewClick = () => {
    !disabled && setEdit(true);
  };

  const handleChange = v => {
    if (withoutControls) {
      onChange(name, v);
    } else {
      setValue(v);
      changeTempValue && changeTempValue(v);
    }
  };

  const handleSave = v => {
    onChange(name, v);
    setLastValue(v);
    setEdit(false);
  };

  const handleCancel = () => {
    setValue(lastValue);
    changeTempValue && changeTempValue(lastValue);
    setEdit(false);
  };

  useEffect(() => {
    edit &&
      noteRef.current?.scrollIntoView({ block: "end", behavior: "smooth" });
  }, [edit]);

  useEffect(() => {
    if (!withoutControls) {
      setValue(defaultValue || "");
      setLastValue(defaultValue || "");
      setEdit(false);
    }
  }, [defaultValue]);

  useEffect(() => {
    setValue(defaultValue || "");
    setLastValue(defaultValue || "");
    setEdit(false);
  }, [shouldUpdateNotesBlockValue]);

  const handleBlur = () => {
    withoutControls && !hasNoteChanges && setEdit(false);
  };

  const displayValue = withoutControls ? defaultValue : value;

  return (
    <div className={clsx(classes.root, className)} ref={noteRef}>
      <Grid container className={classes.header}>
        <Grid item>
          <Typography className={classes.title}>Note</Typography>
        </Grid>
      </Grid>
      {edit ? (
        <Textarea
          autoFocus
          placeholder={placeholder}
          maxLength={250}
          rows={6}
          defaultValue={displayValue}
          onChange={handleChange}
          onSave={handleSave}
          onCancel={handleCancel}
          showControls={!withoutControls}
          onBlur={handleBlur}
        />
      ) : (
        <Box className={classes.notePreview} onClick={handlePreviewClick}>
          {displayValue && (
            <Typography className={classes.noteValue}>
              {displayValue}
            </Typography>
          )}
          {!displayValue && (
            <Typography className={classes.notePlaceholder}>
              {placeholder}
            </Typography>
          )}
        </Box>
      )}
    </div>
  );
};

export default NoteBlock;
